import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/try-exam/[slug]/GuestExamClient.tsx");
